// providerslice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {    
    "measurement_day": '',
    "measurement_month": '',
    "measurement_year": '',
    "reading_type": '',
    "reading":'',
    "alert_type":'',
    "reading_details":'',
    "threshold":'',
    "device_id": '',
    "acknowledged_id":[],
    "alert_type_inverse":'',
    "reading_details_inverse":'',
    "device_id_inverse":'',
    "acknowledged_id_inverse":'',
    "measurement_date_inverse": '',
    "reading_type_inverse": '',
    "reading_inverse":'',
    "threshold_inverse":'',
    "match": false,
    "deviceAlertDashboardSearchApplied": false,

};

const deviceAlertDashboardSearchSlice = createSlice({
    name: 'deviceAlertDashboardSearch',
    initialState,
    reducers: {
        setDeviceAlertDashboardSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetDeviceAlertDashboardSearch(state) {
            return { ...initialState, deviceAlertDashboardSearchApplied: false }; // Reset state and flag
        },
        setDeviceAlertDashboardSearchApplied(state) {
            state.deviceAlertDashboardSearchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const {
    setDeviceAlertDashboardSearch,
    resetDeviceAlertDashboardSearch, setDeviceAlertDashboardSearchApplied } = deviceAlertDashboardSearchSlice.actions;

export default deviceAlertDashboardSearchSlice.reducer;